import templateSlice from "./template.slice";

export * from "./template.slice";
export default templateSlice.reducer;
